import React, { useContext } from "react";
import { arrayOf, bool, node, oneOf, string } from "prop-types";
import AssetsProvider from "@insightfulscience/atomic-react/utils/AssetsProvider";
import { textAlignPropTypes } from "../props/sx";
import { classes } from "../utils/classes";

const HeroBackground = ({ hAlign = "right", vAlign = "bottom", children }) => {
	return (
		<div
			className={classes(
				"section-hero__background",
				`section-hero__background--${hAlign}`,
				`section-hero__background--${vAlign}`,
			)}
		>
			{children}
		</div>
	);
};

HeroBackground.propTypes = {
	hAlign: textAlignPropTypes,
	vAlign: oneOf(["top", "middle", "bottom"]),
	children: node.isRequired,
};

const HeroBackgroundImages = ({
	isBaseUrl = true,
	images = [],
	imagePositions = [],
	color = "transparent",
	children,
}) => {
	const ctxBaseUrl = useContext(AssetsProvider.context);
	const baseUrl = isBaseUrl ? ctxBaseUrl : "";
	const styles = !images.length
		? {}
		: {
				backgroundImage: images.map(src => `url(${baseUrl}${src})`).join(","),
				backgroundPosition: imagePositions.join(","),
				backgroundSize: "auto, auto 100%",
		  };

	return (
		<div
			className={classes("section-hero__background-images", `section-hero-color-${color}`)}
			style={{ ...styles }}
		>
			{children}
		</div>
	);
};

HeroBackgroundImages.propTypes = {
	isBaseUrl: bool,
	images: arrayOf(string),
	imagePositions: arrayOf(string),
	color: oneOf([
		"1",
		"1--light",
		"2",
		"3",
		"4",
		"5",
		"6",
		"white",
		"black--02",
		"dotmatics-8",
		"transparent",
		"gradient",
	]),
	children: node.isRequired,
};

HeroBackground.Images = HeroBackgroundImages;

export default HeroBackground;
